import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Container, Col, Row, Table, InputGroup, Input, InputGroupAddon, Button, FormFeedback, Form } from 'reactstrap';
import Pagination from 'react-js-pagination';
import MaterialIcon from 'material-icons-react';
import i18n from '../../i18next';
import _ from 'lodash';

import {
    DEFAULT_PAGE_SIZE,
    DEFAULT_PAGING_RANGE,
    SUCCESS,
    ONLINE,
    OFFLINE,
    NOT_CONFIGURED,
    PAUSED,
    AUTO_SYNC,
    IMPORT,
    PUBLISH,
    PUBLISH_MENU,
    PUBLISH_CATEGORY,
    PUBLISH_QUESTION,
    PUBLISH_PRODUCT,
    PUBLISH_ANSWER,
    IMPORT_POS_CHARGE_TYPES,
    IMPORT_POS_TENDER_TYPES,
    IMPORT_POS_ORDER_TYPES,
    CREATE_ORDER,
    CREATE_BILLING_CSV,
    IMPORT_IIKO_ADDRESSES,
    FAIL, EXPORT_MENU_FAIL,
    UPDATE_POS_SETTINGS,
    WIPE_MENU,
    PAUSE_ALL_RESTAURANTS,
    PRODUCT_REPORT,
    DOWNLOAD_ORDERS_REPORT,
    CENTRAL_SEARCH_ORDER_REPORT,
    CREATE_CUSTOMER_DATA_CSV,
    MENUU_MASTER_ADMIN,
    MENUU_ADMIN,
    CREATE_INVOICE_HISTORY_CSV,
    DELIVERY_PROVIDER_ERROR
} from '../../utils/Constants';
import { loadJobHistory, clearJobDetails } from '../../actions/index';
import RestaurantUtils from '../../utils/RestaurantUtils';
import { convertSecToMin, localizeStatuses, localizeActions, isUserAllowedToSeePaymentType } from '../../utils/CommonUtils';
import JobDetailsScreen from './JobDetailsScreen';
import SearchButton from '../common/SearchButton';

class JobHistoryScreen extends Component {
    constructor(props) {
        super(props);

        this.state = {
            currentPageNumber: 1,
            advancedSearch: false,
            searchQuery: {
                jobId: '',
                brandName: '',
                location: '',
                startedAt: '',
                action: '',
                status: ''
            },
            jobDetailsScreenOpened: false,
            selectedJob: {},
            stateAlreadyCopiedFromProps: false
        };

        this.handlePageChange = this.handlePageChange.bind(this);
        this.toggleJobDetailsScreen = this.toggleJobDetailsScreen.bind(this);
        this.changeState = this.changeState.bind(this);
        this.keyPress = this.keyPress.bind(this);
        this.search = this.search.bind(this);
        this.clearSearch = this.clearSearch.bind(this);
        this.toggleSearch = this.toggleSearch.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.jobHistory.selectedJob !== this.props.jobHistory.selectedJob) {
            this.setState({ stateAlreadyCopiedFromProps: false });
        }
    }

    componentDidMount() {
        this.props.loadJobHistory(1);
    }

    componentWillUnmount() {
        this.props.clearJobDetails();
        this.resetState();
    }

    copyStateFromProps() {
        const selectedJob = this.props.jobHistory.selectedJob;

        if (!_.isEmpty(selectedJob) && !this.state.stateAlreadyCopiedFromProps) {
            this.setState({
                selectedJob: selectedJob,
                stateAlreadyCopiedFromProps: true
            }, () => this.toggleJobDetailsScreen(selectedJob));
        }
    }

    resetState() {
        this.state.currentPageNumber = 1;
        this.state.jobDetailsScreenOpened = false;
        this.state.selectedJob = {};
        this.state.stateAlreadyCopiedFromProps = false;
    }

    changeState({ target }) {
        this.setState({
            searchQuery: {
                ...this.state.searchQuery,
                [target.name]: target.value,
            }
        });
    }

    toggleJobDetailsScreen(selectedJob) {
        if (!this.state.jobDetailsScreenOpened) {
            this.setState({
                jobDetailsScreenOpened: !this.state.jobDetailsScreenOpened,
                selectedJob: selectedJob
            });
        } else {
            this.setState({
                jobDetailsScreenOpened: !this.state.jobDetailsScreenOpened,
                selectedJob: {}
            });
        }
    }

    search() {
        // new search should always start from page 1
        this.props.loadJobHistory(1, this.state.searchQuery);

        this.setState({
            currentPageNumber: 1
        });
    }

    clearSearch() {
        //new search should always start from page 1
        this.setState({
            searchQuery: {
                jobId: '',
                brandName: '',
                location: '',
                startedAt: '',
                action: '',
                status: ''
            },
            currentPageNumber: 1
        });

        this.props.loadJobHistory(1);
    }

    toggleSearch() {
        // toggling the search should reset the search query
        this.setState({
            advancedSearch: !this.state.advancedSearch,
            searchQuery: {
                jobId: '',
                brandName: '',
                location: '',
                startedAt: '',
                action: '',
                status: ''
            },
            currentPageNumber: 1
        });

        this.props.loadJobHistory(1);
    }

    keyPress(event) {
        if (event.keyCode === 13) { // this is Enter
            this.search();
        }
    }

    handlePageChange(pageNumber) {
        this.setState({
            currentPageNumber: pageNumber
        });

        this.props.loadJobHistory(pageNumber, this.state.searchQuery);
    }

    renderSimpleSearch() {
        const { flexEnd, inputGroupSearch, inputSearch, paddingLeftRight, rowMarginTop, simpleSearchPipe,
            inputGroupAddon, cursorPointer } = styles;
        const { jobId } = this.state.searchQuery;

        return (
            <div>
                <Row>
                    <Col xs="auto" sm={10} >
                        <Row>
                            <Col xs={4} style={paddingLeftRight}>
                                <InputGroup style={inputGroupSearch}>
                                    <Input
                                        type="number" name="jobId" id="jobId" placeholder={i18n.t('screens:jobsHistoryScreen.jobId')}
                                        value={jobId}
                                        onChange={this.changeState}
                                        onKeyDown={this.keyPress}
                                        style={inputSearch} />
                                    <InputGroupAddon addonType="append" style={inputGroupAddon}>
                                        <div onClick={this.search} style={cursorPointer} ><MaterialIcon icon="search" color="#0288D1" size={28} /></div>
                                    </InputGroupAddon>
                                </InputGroup>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row style={rowMarginTop}>
                    <Col xs={10}>
                        <Row>
                            <Col xs={4} style={flexEnd}>
                                <Button color="link" onClick={this.clearSearch}>{i18n.t('common:searchForms.clear')}</Button>
                                <span style={simpleSearchPipe}>|</span>
                                <Button color="link" onClick={this.toggleSearch}>{i18n.t('common:searchForms.advancedSearch')}</Button>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </div>
        );
    }

    onKeyUp(event) {
        event.preventDefault();
        if (event.keyCode === 13) {
            document.getElementById('advanceSearchButton').click();
        }
    }

    renderAdvancedSearch() {
        const { flexEnd, advancedSearchIcon, paddingLeftRight, actionStyle, searchButtonStyle,
            rowMarginTop, advancedSearchPipe } = styles;
        const { jobId, brandName, location, startedAt, action, status } = this.state.searchQuery;

        const isManager = !isUserAllowedToSeePaymentType(this.props.user);
        const isMenuuAdminOrMasterAdmin = this.props.user.role === MENUU_MASTER_ADMIN || this.props.user.role === MENUU_ADMIN ? true : false;

        return (
            <div>
                <Row>
                    <Col xs="auto" sm={10} >
                        <Form id='advanceSearchForm' onKeyUp={this.onKeyUp}>
                            <Row>
                                <Col style={paddingLeftRight}>
                                    <Input type="number" name="jobId" id="jobId" placeholder={i18n.t('screens:jobsHistoryScreen.jobId')} value={jobId} onChange={this.changeState} />
                                </Col>
                                <Col style={paddingLeftRight}>
                                    <Input type="text" name="brandName" id="brandName" placeholder={i18n.t('screens:jobsHistoryScreen.brandName')} value={brandName} onChange={this.changeState} />
                                </Col>
                                <Col style={paddingLeftRight}>
                                    <Input type="text" name="location" id="location" placeholder={i18n.t('screens:restaurantsScreen.location')} value={location} onChange={this.changeState} />
                                </Col>
                                <Col md={2} style={paddingLeftRight}>
                                    <Input type="text" name="startedAt" id="startedAt" placeholder={i18n.t('screens:jobsHistoryScreen.startedAtDate')} value={startedAt} onChange={this.changeState} />
                                </Col>
                                <Col style={actionStyle}>
                                    {/* TODO this should be taken from an API service */}
                                    <Input type="select" name="action" id="action" placeholder={i18n.t('screens:jobsHistoryScreen.action')} value={action} onChange={this.changeState} >
                                        <option value="">{i18n.t('screens:jobsHistoryScreen.action')}</option>
                                        <option hidden={isManager} value={AUTO_SYNC}>{i18n.t('common:actionTypes.autoSync')}</option>
                                        <option hidden={isManager} value={IMPORT}>{i18n.t('common:buttons.import')}</option>
                                        <option value={PUBLISH}>{i18n.t('common:buttons.publish')}</option>
                                        <option value={PUBLISH_MENU}>{i18n.t('common:actionTypes.publishMenu')}</option>
                                        <option value={PUBLISH_CATEGORY}>{i18n.t('common:actionTypes.publishCategory')}</option>
                                        <option value={PUBLISH_PRODUCT}>{i18n.t('common:actionTypes.publishProduct')}</option>
                                        <option value={PUBLISH_QUESTION}>{i18n.t('common:actionTypes.publishQuestion')}</option>
                                        <option value={PUBLISH_ANSWER}>{i18n.t('common:actionTypes.publishAnswer')}</option>
                                        <option hidden={isManager} value={IMPORT_POS_CHARGE_TYPES}>{i18n.t('common:actionTypes.importPosCharges')}</option>
                                        <option hidden={isManager} value={IMPORT_POS_TENDER_TYPES}>{i18n.t('common:actionTypes.importPosTenders')}</option>
                                        <option hidden={isManager} value={IMPORT_POS_ORDER_TYPES}>{i18n.t('common:actionTypes.importPosOrders')}</option>
                                        <option value={CREATE_ORDER}>{i18n.t('screens:jobsHistoryScreen.createOrder')}</option>
                                        <option hidden={isManager} value={CREATE_BILLING_CSV}>{i18n.t('screens:jobsHistoryScreen.createBillingCSV')}</option>
                                        <option hidden={isManager} value={IMPORT_IIKO_ADDRESSES}>{i18n.t('screens:jobsHistoryScreen.importIIKOaddresses')}</option>
                                        <option hidden={isManager} value={EXPORT_MENU_FAIL}>{i18n.t('screens:jobsHistoryScreen.exportMenuFail')}</option>
                                        <option hidden={isManager} value={UPDATE_POS_SETTINGS}>{i18n.t('screens:mainContainer.UPDATE_POS_SETTINGS')}</option>
                                        <option hidden={isManager} value={WIPE_MENU}>{i18n.t('common:actionTypes.wipeMenu')}</option>
                                        <option hidden={isManager} value={PAUSE_ALL_RESTAURANTS}>{i18n.t('common:actionTypes.pauseAllRestaurants')}</option>
                                        <option value={PRODUCT_REPORT}>{i18n.t('screens:mainContainer.PRODUCT_REPORT')}</option>
                                        <option value={DOWNLOAD_ORDERS_REPORT}>{i18n.t('screens:mainContainer.DOWNLOAD_ORDERS_REPORT')}</option>
                                        <option hidden={isManager} value={CENTRAL_SEARCH_ORDER_REPORT}>{i18n.t('screens:mainContainer.CENTRAL_SEARCH_ORDER_REPORT')}</option>
                                        <option hidden={!isMenuuAdminOrMasterAdmin} value={CREATE_CUSTOMER_DATA_CSV}>{i18n.t('screens:jobsHistoryScreen.downloadCustomersData')}</option>
                                        <option hidden={!isMenuuAdminOrMasterAdmin} value={CREATE_INVOICE_HISTORY_CSV}>{i18n.t('screens:jobsHistoryScreen.createInvoiceHistoryCSV')}</option>
                                        <option hidden={isManager} value={DELIVERY_PROVIDER_ERROR}>{i18n.t('screens:mainContainer.DELIVERY_PROVIDER_ERROR')}</option>
                                    </Input>
                                </Col>
                                <Col style={actionStyle}>
                                    {/* TODO this should be taken from an API service */}
                                    <Input type="select" name="status" id="status" placeholder={i18n.t('screens:jobsHistoryScreen.status')} value={status} onChange={this.changeState} >
                                        <option value="">{i18n.t('screens:jobsHistoryScreen.status')}</option>
                                        <option value={SUCCESS}>{i18n.t('common:statuses.success')}</option>
                                        <option value={FAIL}>{i18n.t('common:statuses.fail')}</option>
                                    </Input>
                                </Col>
                                <Col>
                                    <SearchButton search={this.search.bind(this)} />
                                </Col>
                            </Row>
                        </Form>
                    </Col>
                </Row>
                <Row style={rowMarginTop}>
                    <Col xs={10} style={flexEnd}>
                        <Button color="link" onClick={this.clearSearch}>{i18n.t('common:searchForms.clear')}</Button>
                        <span style={advancedSearchPipe}>|</span>
                        <Button color="link" onClick={this.toggleSearch}>{i18n.t('common:searchForms.simpleSearch')}</Button>
                    </Col>
                </Row>
            </div>
        );
    }

    renderHeading() {
        const { screenHeading } = styles;

        return (
            <Col sm={1} style={screenHeading}>
                <div><MaterialIcon icon="assignment" color="#0288d1" size={22} />&nbsp;
                    {i18n.t('screens:restaurantsMainContainer.jobs')}</div>
            </Col>
        );
    }

    renderJobHistoryTable() {
        const { zeroPadding } = styles;

        return (
            <Col style={zeroPadding}>
                <Table responsive hover>
                    <thead>
                        <tr className="d-flex">
                            <th className="col-1">{i18n.t('screens:jobsHistoryScreen.jobId')}</th>
                            <th className="col-2">{i18n.t('screens:jobsHistoryScreen.user')}</th>
                            <th className="col-2">{i18n.t('screens:jobsHistoryScreen.restaurant')}</th>
                            <th className="col-2">{i18n.t('screens:jobsHistoryScreen.startedAt')}</th>
                            <th className="col-1">{i18n.t('screens:jobsHistoryScreen.duration')}</th>
                            <th className="col-1">{i18n.t('screens:jobsHistoryScreen.action')}</th>
                            <th className="col-1">{i18n.t('screens:orderHistoryScreen.status')}</th>
                            <th className="col-2">{i18n.t('screens:jobsHistoryScreen.scheduledAt')}</th>
                        </tr>
                    </thead>
                    <tbody>{this.renderTableRows()}</tbody>
                </Table>
            </Col>
        );
    }

    renderTableRows() {
        const { jobId } = styles;

        if (this.props.jobHistory.content !== undefined && this.props.jobHistory.content !== null) {
            return this.props.jobHistory.content.map((job, i) => {

                const jobStatusChange = job.status === SUCCESS ? ONLINE : OFFLINE;
                const jobStatusColor = RestaurantUtils.getPosStatusColor(jobStatusChange);
                const statusColor = { color: jobStatusColor };

                return (
                    <tr key={i} className="d-flex">
                        <td className="col-1">
                            <span style={jobId} onClick={() => this.toggleJobDetailsScreen(job)}>
                                {job.id}
                            </span>
                        </td>
                        <td className="col-2 longerNamesStyle">{job.userName}</td>
                        <td className="col-2">{job.restaurantName}</td>
                        <td className="col-2">
                            {job.startedAt}
                        </td>
                        <td className="col-1">{convertSecToMin(job.duration)}</td>
                        <td className="col-1">{localizeActions(job.action)}</td>
                        <td style={statusColor} className="col-1">{localizeStatuses(job.status)}</td>
                        <td className="col-2">{job.scheduledAt}</td>
                    </tr>
                );
            });
        } else {
            return <tr></tr>;
        }
    }

    renderPagination() {
        const { flexEnd } = styles;

        return (
            <Col style={flexEnd}>
                <Pagination
                    activePage={this.props.jobHistory.number + 1}
                    itemsCountPerPage={DEFAULT_PAGE_SIZE}
                    totalItemsCount={this.props.jobHistory.totalElements}
                    pageRangeDisplayed={DEFAULT_PAGING_RANGE}
                    itemClass='page-item'
                    linkClass='page-link'
                    onChange={this.handlePageChange}
                />
            </Col>
        );
    }

    render() {
        const { containerStyle } = styles;

        this.copyStateFromProps();

        return (
            <Container fluid style={containerStyle}>
                {!this.state.advancedSearch ? this.renderAdvancedSearch() : this.renderSimpleSearch()}
                <Row>{this.renderHeading()}</Row>
                <Row>{this.renderJobHistoryTable()}</Row>
                <Row>{this.renderPagination()}</Row>
                <JobDetailsScreen isOpen={this.state.jobDetailsScreenOpened} onToggle={() => this.toggleJobDetailsScreen(this.state.selectedJob)} selectedJob={this.state.selectedJob} />
            </Container>
        );
    }
}

const mapStateToProps = state => {
    return {
        jobHistory: state.jobHistory,
        user: state.user
    }
}

export default connect(mapStateToProps, { loadJobHistory, clearJobDetails })(JobHistoryScreen);

const styles = {
    containerStyle: {
        width: '96%',
        marginTop: 20
    },
    zeroPadding: {
        paddingLeft: 0,
        paddingRight: 0
    },
    flexEnd: {
        display: 'flex',
        justifyContent: 'flex-end',
        paddingRight: 0
    },
    jobId: {
        color: '#0288D1',
        cursor: 'pointer'
    },
    screenHeading: {
        display: 'flex',
        borderBottom: '1px solid rgb(222, 226, 230)',
        marginBottom: 20,
        paddingLeft: 0,
        color: '#0288d1'
    },
    inputGroupSearch: {
        border: '1px solid lightgray'
    },
    inputSearch: {
        border: 0
    },
    paddingLeftRight: {
        paddingLeft: 5,
        paddingRight: 5
    },
    searchButtonStyle: {
        width: '100%',
        verticalAlign: 'middle !important'
    },
    rowMarginTop: {
        marginBottom: 20
    },
    advancedSearchPipe: {
        height: 46,
        textAlign: 'center',
        verticalAlign: 'middle',
        padding: '10px 0',
        color: '#007bff'
    },
    simpleSearchPipe: {
        height: 46,
        textAlign: 'center',
        verticalAlign: 'middle',
        padding: '10px 0',
        color: '#007bff'
    },
    inputGroupAddon: {
        marginTop: '10px'
    },
    cursorPointer: {
        cursor: 'pointer'
    },
    advancedSearchIcon: {
        float: 'left'
    },
    actionStyle: {
        paddingLeft: 5,
        paddingRight: 5
    }
}


// WEBPACK FOOTER //
// ./src/components/jobhistory/JobHistoryScreen.js